import { useDonorProfile, useGiftSummary } from '../../../api';
import { useFeatureFlag } from '../../../providers';
import { FeatureFlag } from '../../../constants';

export const useHistory = () => {
    const { isFeatureEnabled } = useFeatureFlag();
    const { giftSummary: gift, isLoading, hasNeverFetched } = useGiftSummary();
    const { isError: isDonorProfileError } = useDonorProfile();

    const nextPage =
        gift?.all.count === 1 && isFeatureEnabled(FeatureFlag.OGA_APPHISTORY)
            ? 'HOME'
            : 'HISTORY';

    return {
        loading: !isDonorProfileError && (isLoading || hasNeverFetched),
        nextPage,
    };
};
